<template>
  <div class="my-2">
    <template v-if="isTranshipment">
      <v-card-title class="py-1 d-flex justify-space-between align-center">
        <h5 class="card-title" style="word-break: break-word">{{ getTranshipmentDeliveryTitle() }}</h5>
      </v-card-title>
      <v-card-text class="d-flex flex-column py-2 cargos" style="max-height: 105px; min-height: 65px; overflow-y: auto">
        <span v-for="({ boardingNumber, qteDeliveries }, i) in delivery.cargos" :key="i">
          Carga {{ boardingNumber }}: {{ qteDeliveries }} entregas
        </span>
      </v-card-text>
    </template>
    <template v-else>
      <v-card-title class="py-1 d-flex justify-space-between align-center">
        <h5 class="card-title">Entrega {{ getCteNumber() }}</h5>
        <v-progress-linear
          :value="getFinishedCtesPercentage()"
          height="15"
          class="progress pa-0 ma-0"
          color="lighten-2 cyan"
          striped
        >
          <small style="font-size: x-small"
            ><strong>{{ getCtesQuantityFinished() }}</strong></small
          >
        </v-progress-linear>
      </v-card-title>
      <v-card-text class="d-flex flex-column py-2">
        <span> Tipo: {{ getBoardingType() }} </span>
        <span> Transbordo: {{ getTranshipmentName() }} </span>
        <span> Cidade: {{ getCity() }}</span>
        <span> Previsão de entrega: {{ getDeliveryForecast() }} </span>

        <status :status="getCteStatuses()" />
      </v-card-text>
    </template>
  </div>
</template>

<script>
import Status from '../Management/Status.vue';
import { format } from 'date-fns';
import { pt } from 'date-fns/locale';
export default {
  components: {
    Status
  },

  props: {
    delivery: {
      default: null,
      type: Object
    },

    isTranshipment: {
      default: false,
      type: Boolean
    }
  },

  data: () => ({
    skill: 20
  }),

  methods: {
    getCteNumber() {
      return this.delivery !== null ? this.delivery.number : '40028922';
    },

    getCteStatuses() {
      return this.delivery !== null ? this.delivery.status : [];
    },

    getTranshipmentName() {
      return this.delivery !== null ? this.delivery.responsibleName : '-';
    },

    getCity() {
      return this.delivery !== null ? this.delivery.cityName : '-';
    },

    getFinishedCtesPercentage() {
      return this.delivery !== null ? this.delivery.nfeInfo.percentageNfeFinished : '0';
    },

    getCtesQuantityFinished() {
      const { qtdNfe, qtdNfeFinished } = this.delivery.nfeInfo;
      return this.delivery !== null ? `${qtdNfeFinished}/${qtdNfe}` : '-';
    },

    getBoardingType() {
      if (this.delivery !== null) {
        return this.delivery.isDirectDeliverer ? 'Entrega Direta' : 'Entrega de Transbordo';
      } else {
        return ' - ';
      }
    },

    getTranshipmentDeliveryTitle() {
      return `${this.delivery.transhipmentName} (TP ${this.delivery.transhipmentCity})`;
    },

    getDeliveryForecast() {
      const { deliveryForecast } = this.delivery;
      return this.delivery !== null ? format(new Date(deliveryForecast), 'P', { locale: pt }) : '-';
    }
  }
};
</script>

<style scoped>
::v-deep.progress {
  width: 60px;
}
.card-title {
  color: #505050;
  font-size: 0.95rem;
  font-weight: 600;
}
/* ===== Scrollbar CSS ===== */
/* Firefox */
.cargos {
  scrollbar-width: thin;
  scrollbar-color: #c7c7c7 #ffffff;
}

/* Chrome, Edge, and Safari */
.cargos::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}

.cargos::-webkit-scrollbar-track {
  background: #ffffff;
}

.cargos::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
::v-deep .cargos::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
</style>
